import { useCallRequestPage } from './callRequest/useCallRequestPage'
import {
  BackButton,
  Button,
  EnrollmentHelpText,
  FormInput,
  SearchableSelect,
  Toast
} from '@/shared/components'
import {
  ENROLLMENT_FIELD_LABELS,
  ENROLLMENT_LOCATION_MESSAGES
} from '../constants/enrollmentContent'

export function CallRequestPage() {
  const {
    branchesLoading,
    errors,
    form,
    locationOptions,
    navigate,
    submit,
    submitCallRequest,
    submitError,
    setSubmitError,
    update
  } = useCallRequestPage()

  return (
    <div className="bg-white px-4 py-10">
      {submitError && <Toast message={submitError} onClose={() => setSubmitError(null)} />}
      <div className="mx-auto max-w-4xl animate-fade-in-up">
        <div className="mb-4">
          <BackButton onClick={() => navigate('/application')} className="w-full justify-start" />
        </div>
        <div className="mx-auto max-w-md pt-2">
          <div className="mb-6 text-center">
            <h1 className="modal-heading__title text-center">Request a Call</h1>
            <p className="modal-heading__subtitle mt-2 text-center">
              An enrollment advisor will contact you with next steps.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <FormInput
              label={ENROLLMENT_FIELD_LABELS.firstName}
              placeholder={ENROLLMENT_FIELD_LABELS.firstName}
              value={form.firstName}
              error={!!errors.firstName}
              onChange={value => update('firstName', value)}
            />
            {errors.firstName && <p className="-mt-3 text-xs text-red-500">{errors.firstName}</p>}

            <FormInput
              label={ENROLLMENT_FIELD_LABELS.lastName}
              placeholder={ENROLLMENT_FIELD_LABELS.lastName}
              value={form.lastName}
              error={!!errors.lastName}
              onChange={value => update('lastName', value)}
            />
            {errors.lastName && <p className="-mt-3 text-xs text-red-500">{errors.lastName}</p>}

            <FormInput
              label="Email"
              placeholder="Email"
              type="email"
              value={form.email}
              error={!!errors.email}
              onChange={value => update('email', value)}
            />
            {errors.email && <p className="-mt-3 text-xs text-red-500">{errors.email}</p>}

            <FormInput
              label={ENROLLMENT_FIELD_LABELS.phoneNumber}
              placeholder={ENROLLMENT_FIELD_LABELS.phoneNumber}
              value={form.phone}
              error={!!errors.phone}
              onChange={value => update('phone', value)}
            />
            {errors.phone && <p className="-mt-3 text-xs text-red-500">{errors.phone}</p>}

            {branchesLoading ? (
              <div className="h-[52px] animate-pulse rounded-[8px] bg-gray-100" />
            ) : (
              <SearchableSelect
                label="Preferred Branch"
                options={locationOptions}
                value={form.trainingLocationExternalId}
                onChange={value => update('trainingLocationExternalId', value)}
                placeholder="Type to search branches..."
                disabled={locationOptions.length === 0}
              />
            )}
            {!branchesLoading && locationOptions.length === 0 ? (
              <p className="-mt-2 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm leading-6 text-amber-900">
                {ENROLLMENT_LOCATION_MESSAGES.noBranches}
              </p>
            ) : null}

            <FormInput
              label="Preferred Call Time"
              placeholder="Morning, afternoon, or a specific time"
              value={form.preferredCallTime}
              onChange={value => update('preferredCallTime', value)}
            />

            <div>
              <label className="enrollment-field-label">Notes</label>
              <textarea
                value={form.notes}
                onChange={event => update('notes', event.target.value)}
                className="enrollment-field-control enrollment-field-control--textarea"
                placeholder="Anything we should know before we call?"
              />
            </div>

            <Button
              type="button"
              fullWidth
              loading={submitCallRequest.isPending}
              onClick={() => {
                void submit()
              }}
            >
              Request Call
            </Button>
          </div>

          <div className="mt-6 text-center">
            <EnrollmentHelpText />
          </div>
        </div>
      </div>
    </div>
  )
}
